/* eslint-disable react/jsx-indent-props */
import React, { useEffect } from "react";
import Layout from "../components/layout";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { shallowEqual, useSelector } from "react-redux";
import axios from "axios";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import BackButton from "../components/backbutton";
import OperatingHoursComponent from "../components/OperatingHoursComponent";
import ContactDetailComponent from "../components/ContactDetailComponent";
import LobbyEscalatorsOperatingGuideComponent from "../components/LobbyEscalatorsOperatingGuide";

const GetInfoDetail = observer(() => {
  const { generalStore } = useStores();
  const { id } = useParams();

  useEffect(() => {
    generalStore.activePage = "get-info";
  }, []);

  const getTitle = () => {
    switch (id) {
      case "operating-hours":
        return "Operating Hours of Family Justice Courts";
      case "contact-details":
        return "Contact Details";
      case "lobby-operating-guide":
        return "Using The Right Lobby and Escalators";
      default:
        break;
    }
  };

  const getContent = () => {
    switch (id) {
      case "operating-hours":
        return <OperatingHoursComponent />;
      case "contact-details":
        return <ContactDetailComponent />;
      case "lobby-operating-guide":
        return <LobbyEscalatorsOperatingGuideComponent />;
      default:
        break;
    }
  };

  return (
    <Layout>
      <div className="h-full w-full flex flex-col">
        <div className="h-[70px] md:h-[80px] w-full bg-bgColor flex justify-start items-center p-4 md:px-28">
          <BackButton />
        </div>
        <div className="bg-[#e0dcd8] flex flex-row justify-between items-center h-[120px] md:h-[160px]">
          <div className="px-4 md:px-28">
            <p className="text-xl md:text-[40px] font-bold">{getTitle()}</p>
          </div>
          <div className="relative h-[120px] md:h-[160px]">
            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#e0dcd8] to-transparent z-10 "></div>
            <img
              src={require(`../assets/images/${id}.png`)}
              className="w-[200px] h-[120px] md:h-[160px]"
            />
          </div>
          {/* <img
            src={require(`../assets/images/${id}.png`)}
            className="w-[200px]"
          /> */}
        </div>
        {/* body */}
        <div className="flex-grow w-full flex flex-col items-center overflow-y-scroll p-4 bg-whiteBg md:px-28">
          {getContent()}
        </div>
      </div>
    </Layout>
  );
});

export default GetInfoDetail;
